// Layout
const dashboardLayout = () => import('@/layouts/DashboardLayout/dashboardLayout.vue')

const superAdminDashboard = () => import('./views/index')

// start Routes
export default [
  {
    path: '/',
    name: 'index',
    component: dashboardLayout,
    children: [{
      path: '',
      name: 'indexDash',
      meta: {
        name: 'indexDash',
        userType: '',
        permission: ''
      },
      component: superAdminDashboard
    }
    ]
  }
]
